import React from "react";
import { Table, Tag, Space } from "antd";
import {
  CloseCircleOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import TrainingRegistrationsListActionsContainer from "../../../../containers/adminRole/trainingRegistration/TrainingRegistrationsListActionsContainer";
import { getUTMLabelIndonesian } from "../../../../libs";

export default function TrainingRegistrationsList({
  trainingRegistrations = [],
  loading = false,
  totalTrainingRegistrations = 0,
  pageSize = 6,
  currentPage = 1,
  onChangeCurrentPage,
  onChangePageSize,
  utmParams,
}) {
  const getColumns = () => [
    {
      title: "#",
      dataIndex: "id",
      align: "center",
      width: 1,
    },
    {
      title: "Nama",
      dataIndex: "participant",
      // width: 150,
      // ellipsis: true,
      render: (participant, item) => (
        <>
          <Link to={"/training-registration/" + item.id}>
            {participant.name}
          </Link>
          <br />
          {participant.email}
        </>
      ),
    },
    {
      title: "Training",
      dataIndex: "training",
      responsive: ["sm"],
      render: (training, item) => (
        <>
          <Space>
            {training.training_option.name}
            {/* <br />*/}
            {!item.is_online ? (
              <Tag color="magenta" style={{ margin: 0 }}>
                {training.location}
              </Tag>
            ) : (
              <Tag color="blue" style={{ margin: 0 }}>
                online
              </Tag>
            )}
          </Space>
          <br />
          {training.dates_summary}
        </>
      ),
    },
    // {
    //   title: "Jenis",
    //   dataIndex: "is_retraining",
    //   responsive: ["sm"],
    //   align: "center",
    //   render: (isRetraining) => (isRetraining ? "Mengulang" : "Reguler"),
    // },
    {
      title: (<>Jenis<br />Status</>),
      dataIndex: "type",
      responsive: ["sm"],
      align: "center",
      render: (type, field) => <>
        {type ? <>
          {type == "regular" ? "Reguler" : ""}
          {type == "retraining" ? "Mengulang" : ""}
          {type == "private" ? "Private" : ""}
          {type == "rescheduled" ? "Rescheduled" : ""}
        </> : <>
          {field.is_retraining ? "Mengulang" : "Reguler"}
        </>}
        <br />
        {!field.is_retraining ? (
          <Tag
            icon={
              field.status === "paid_off" ? (
                <CheckCircleOutlined />
              ) : field.status === "canceled" ? (
                <CloseCircleOutlined />
              ) : (
                <ClockCircleOutlined />
              )
            }
            color={
              field.status === "paid_off"
                ? "success"
                : field.status === "canceled"
                  ? "error"
                  : "default"
            }
            style={{ margin: 0 }}
          >
            {field.status === "paid_off"
              ? "lunas"
              : field.status === "canceled"
                ? "batal"
                : field.status === "waiting_for_paid_off"
                  ? "belum lunas"
                  : "belum bayar"}
          </Tag>
        ) : (
          "-"
        )}
      </>,
    },
    {
      title: "UTM Params",
      responsive: ["sm"],
      align: "center",
      dataIndex: "utm_params",
      render: (utmDataString, item) =>
        !item.is_retraining ? <>
          {utmDataString ? (
            <Space wrap>
              {(() => {
                try {
                  const parsed = JSON.parse(utmDataString);
                  return Object.entries(parsed).map(([key, value]) => {
                    const description = utmParams && utmParams[key] ? utmParams[key][value] : null;
                    return (
                      <Tag key={key}>
                        <strong>{getUTMLabelIndonesian(key)}</strong>
                        {/* <span>{value}</span> */}
                        <br />
                        {description && <span>{description}</span>}
                      </Tag>
                    );
                  });
                } catch (e) {
                  return utmDataString;
                }
              })()}
            </Space>
          ) : (
            "-"
          )}
        </> : "-",
    },
    {
      title: "Audit",
      responsive: ["sm"],
      align: "center",
      dataIndex: "audited",
      render: (audited, item) => <>
        <Tag
          icon={
            audited ? (
              <CheckCircleOutlined />
            ) : (
              <CloseCircleOutlined />
            )
          }
          color={audited ? "success" : "error"}
          style={{ margin: 0 }}
        >
          {audited ? "Sudah" : "Belum"}
        </Tag>
        <br />
        <span>{item.audited_note ? item.audited_note : "-"}</span>
      </>
    },
    {
      title: "Lead",
      responsive: ["sm"],
      align: "center",
      dataIndex: "lead",
      render: (lead, item) => <>
        <span>
          {lead ? lead : "-"}
        </span>
        <br />
        <span>{item.lead_note ? item.lead_note : "-"}</span>
      </>
    },
    {
      title: "Kode transfer",
      responsive: ["sm"],
      align: "center",
      dataIndex: "transfer_code",
      render: (transferCode, item) =>
        !item.is_retraining ? (transferCode ? transferCode : "-") : "-",
    },
    {
      width: 10,
      render: (item) => (
        <TrainingRegistrationsListActionsContainer trainingRegistration={item} />
      ),
    },
  ];

  return (
    <Table
      size="small"
      dataSource={trainingRegistrations.map((t) => ({ ...t, key: t.id }))}
      loading={loading}
      columns={getColumns()}
      pagination={{
        total: totalTrainingRegistrations,
        pageSize: pageSize,
        current: currentPage,
        onChange: (page, size) => {
          onChangeCurrentPage(page);
          onChangePageSize(size);
        },
        position: ["bottomCenter"],
      }}
    />
  );
}
